import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faShareAlt,faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
export default function Home({ sendblog }) {
  const handleShare = (title, link) => {
    if (navigator.share) {
      navigator
        .share({
          title: title,
          text: "Check out this blog post!",
          url: link,
        })
        .then(() => console.log("Shared successfully"))
        .catch((error) => console.error("Error sharing:", error));
    } else {
      alert("Sharing is not supported on this device/browser.");
    }
  };
  return (
    <>
      <div className="py-24 flex-row items-center justify-center px-4">
        <h1
          role="heading"
          className="text-center xl:text-5xl md:text-4xl text-2xl font-bold text-gray-800"
        >
          Read Our Latest
        </h1>
        <p
          role="contentinfo"
          className="text-base leading-normal text-center text-slate-300 mt-4 bg-black rounded-3xl"
        >
          Welcome to the JNY blog, a treasure trove of insights carefully
          crafted by our team of experts. Immerse yourself in the world of
          cutting-edge trends, innovative technologies, and captivating
          discussions that are shaping the digital landscape. Our mission is to
          empower both businesses and individuals with practical tips, expert
          guidance, and creative ideas. Whether you're seeking guidance on
          software development, optimizing business processes, or exploring
          industry-specific solutions, our blog covers a wide array of topics.
          Stay informed about the rapidly evolving technology landscape,
          discover best practices, and gain a competitive advantage in your
          industry. Join our vibrant community of forward-thinkers, participate
          in engaging conversations, and unlock the limitless potential at the
          intersection of technology and business. Embark on an enlightening
          journey through the JNY blogosphere!
        </p>

        <hr className="bg-black"></hr>

        <div className="my-5 2xl:container 2xl:mx-auto flex flex-wrap items-center justify-center pt-6 gap-6 hover:cursor-zoom-in">
          {sendblog.map((f, index) => (
            <div
              key={index}
              className="relative lg:flex-row sm:flex-row flex-col items-center lg:gap-0 gap-6 lg:w-96 w-full sm:w-auto"
            >
              <img
                src={URL.createObjectURL(f.Image)}
                alt="woman smiling"
                className="w-full"
              />
              <div>
                <div>
                  <h2 className="text-xl font-semibold leading-5 mt-2 text-gray-800">
                    {f.Title}
                  </h2>

                  <p className="text-base mt-2 italic font-italic leading-4 text-gray-600">
                    <FontAwesomeIcon icon={faCalendarAlt} className="mr-2" />
                    {f.Date}
                  </p>
                </div>
                <p>
                  {f.Description}<br></br>
                  
                  <a className="text-black" href={f.link} target="_blank" rel="noopener noreferrer">
                   Read more <FontAwesomeIcon icon={faArrowCircleRight} className="mr-2" />
                  </a>
                </p>
                <button
                  className="mt-3 bg-black hover:bg-green-500 text-white font-bold py-2 px-2 rounded"
                  onClick={() => handleShare(f.Title, f.link)}
                >
                  <FontAwesomeIcon icon={faShareAlt} className="mr-2" />
                  Share
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
